import { PIE_VALUES_TO_OMIT } from 'modules/spaceLook/constants';

const isPieValueToOmit = (value) => PIE_VALUES_TO_OMIT.includes(value);

export default isPieValueToOmit;
